export default "__VITE_ASSET__b4ed0c38__"